import React, { useCallback, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import { TokenType } from '@vatom/sdk/core'
import { useThrottle } from '@vatom/sdk/react'
import { translate } from '@vatom/utils'
import { Status, theme, Toast } from '@vatom/wombo'
import { Actionsheet } from 'native-base'

// import Success from './partials/Success'
import Alert from '../../../components/Alert'
import logger from '../../../logger'

import ConfirmModal from './partials/ConfirmModal'
import Map from './partials/Map'
import { LatLng } from './react-native-maps'

interface ActionSheetDropProps {
  setOpen: (b: boolean) => void
  isOpen: boolean
  token: TokenType
}

export const ActionSheetDrop = ({ isOpen, setOpen, token }: ActionSheetDropProps) => {
  logger.info('ActionSheetDrop')
  const navigation = useNavigation()
  // const [isDropSuccess, setIsDropSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [markerLocation, setMarkerLocation] = useState<LatLng>()

  const onCancel = useCallback(() => setIsConfirmOpen(false), [])

  const onDrop = useCallback(async (latitude: number, longitude: number) => {
    setMarkerLocation({
      latitude,
      longitude
    })
    setIsConfirmOpen(true)
  }, [])

  const drop = useThrottle((coords: LatLng) => {
    token
      .performAction('Drop', {
        'geo.pos': { Lat: coords.latitude, Lon: coords.longitude }
      })
      .then($ => {
        Toast({
          title: translate('dropNft.success', { name: token.metadata.name }),
          placement: 'top',
          status: Status.success
        })
      })
      .catch(Alert.showError)
  }, 1000)

  const doDrop = () => {
    if (!token && !isLoading) return
    navigation.goBack()
    setIsConfirmOpen(false)
    setIsLoading(true)
    // InteractionManager.runAfterInteractions(() => {
    if (markerLocation) {
      drop(markerLocation)
      setOpen(false)
    }
    // })
  }

  return (
    <Actionsheet
      p={2}
      _light={{
        backgroundColor: theme.colors.white
      }}
      _dark={{
        backgroundColor: theme.colors.grayDarkMode[900]
      }}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      useRNModal={true}
      // @ts-ignore prop doesn't exit on types
      _backdropFade={{
        entryDelay: 150,
        exitDelay: 10
      }}
    >
      <Map isOpen={isOpen} onDrop={onDrop} onClose={() => setOpen(false)} isLoading={isLoading} />
      <ConfirmModal token={token} isOpen={isConfirmOpen} onCancel={onCancel} onDrop={doDrop} />
    </Actionsheet>
  )
}
export default ActionSheetDrop
